import { memo } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import SelectAmong from "@vms/SelectAmong";
import SelectFilters from "@vms/SelectFilters";
import { useSelectedKeywordsContext } from "@vms/SelectedKeywords/SelectedKeywordsContext";
import FilterResultsHeadline from "@vms/FilterResultsHeadline";

const VisualizeFilters: FCX<{
    resultCount: number;
}> = ({
    resultCount,
}) => {
    const { isSelectedKeywordsView } = useSelectedKeywordsContext();

    return (
        <div className="VisualizeFilters">
            <FilterResultsHeadline resultCount={resultCount}/>
            <div className="VisualizeFilters__headline-filters">
                <SelectAmong
                    className="VisualizeFilters__select VisualizeFiltersSelect"
                    label={<span data-testid="textVisualizeRespondentType">AMONG:</span>}
                    testId="selectVisualizeAmong"
                    useGroupsLimit
                    useCoExclusions
                />
                {!isSelectedKeywordsView && (
                    <SelectFilters
                        className="VisualizeFilters__filters"
                        testId="buttonVisualizeFilters"
                    />
                )}
            </div>
        </div>
    )
}

export default memo(VisualizeFilters);